import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebase/config';
import { useAuth } from '../../context/AuthContext';
import './Planning.css';

const Planning = () => {
  const { currentUser } = useAuth();
  const [rendezvous, setRendezvous] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const rendezvousRef = ref(database, 'rendezvous/' + currentUser.uid);
    
    onValue(rendezvousRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const rendezvousList = Object.entries(data).map(([id, value]) => ({
          id,
          ...value
        }));
       
        const aujourdhui = new Date();
        const aVenir = rendezvousList.filter(r => new Date(r.date) >= aujourdhui);
        setRendezvous(aVenir.sort((a, b) => new Date(a.date) - new Date(b.date)));
      } else {
        setRendezvous([]);
      }
      setLoading(false);
    });
  }, [currentUser]);

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="planning-container">
      <h2>Mes rendez-vous à venir</h2>
      
      {rendezvous.length === 0 ? (
        <p className="no-data">Aucun rendez-vous planifié</p>
      ) : (
        <div className="rendezvous-list">
          {rendezvous.map((rdv) => (
            <div key={rdv.id} className={`rendezvous-card statut-${rdv.statut}`}>
              <div className="rdv-header">
                <span className="rdv-date">
                  {new Date(rdv.date).toLocaleDateString('fr-FR', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </span>
                <span className={`statut-badge ${rdv.statut}`}>
                  {rdv.statut}
                </span>
              </div>
              
              <div className="rdv-details">
                <p><strong>Départ:</strong> {rdv.adresseDepart}</p>
                <p><strong>Arrivée:</strong> {rdv.adresseArrivee}</p>
                <p><strong>Type:</strong> {rdv.typeService}</p>
                {rdv.message && <p><strong>Message:</strong> {rdv.message}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Planning;